// Copyright (c) 2020-2021 Visual Intelligence LP. All rights reserved.
//
export interface DatumDTO {
  id: number;
  name: string;
}

export default class Datum {
  id: number;
  name: string;

  constructor(dto: Partial<DatumDTO>) {
    this.update(dto);
  }

  get asJson(): DatumDTO {
    return {
      id: this.id,
      name: this.name
    };
  }

  update(newData: Partial<DatumDTO>): DatumDTO {
    const allData = { ...this.asJson, ...newData };

    Object.assign(this, allData);

    return this.asJson;
  }
}